module.exports = __webpack_public_path__ + "models/scene2kids.dfecf15.txt";